const csv_headers = [
    {label: 'Geography', key: 'geo_type'},
    {label: 'Name', key: 'geo_name'},
    {label: 'Population', key: 'population'},
    {label: 'Category', key: 'category'},
    {label: 'Number', key: 'total'},
  ];
export default csv_headers;

export const csv_footer =  [
  {geo_type: 'Source', 'geo_name': 'Australian Bureau of Statistics, 2017'},
  {geo_type: 'Compiled by', 'geo_name': 'Geografia, 2018'}
]
export const get_csv_data = (data) => {
  return [...data, ...csv_footer]
}

export const data_items = 10;
export const data_items_detail = 100;


// WEBPACK FOOTER //
// ./src/data/csv.js